// @flow

import React, {useState} from 'react';
import {useSidebar} from 'docs/data';

import {SidebarContainer} from '../SidebarContainer';
import {SidebarNavigation} from '../navigation/SidebarNavigation';
import {SidebarFooter} from '../footer/SidebarFooter';
import {XRaySidebarContent} from './XRaySidebarContent';
import {XRayToggle} from './XRayToggle';

import type {XRayMode} from './XRayMode';

export const XRaySidebar = () => {
  const [mode, setMode] = useState<XRayMode>('normal');
  const {open} = useSidebar();

  let background;
  let content;
  let footer;

  if (mode === 'xray') {
    background = 'gray50';
    content = <XRaySidebarContent hide={() => setMode('normal')} />;
  } else {
    background = 'white';
    content = <SidebarNavigation />;
    footer = <SidebarFooter />;
  }

  return (
    <SidebarContainer background={background}>
      {content}
      {footer}
      {mode !== 'disabled' && open && (
        <XRayToggle mode={mode} setMode={setMode} />
      )}
    </SidebarContainer>
  );
};
